import React from 'react';
import Message from './Message';
import { useApp } from '../../context/AppContext';

const Notifications = () => {
	const { messages, setMessages } = useApp();

	const removeMessage = (messageId) => {
		setMessages((prevMessages) => prevMessages.filter((msg) => msg.id !== messageId));
	};

	const RenderMessages = () => {
		return messages.map((message) => (
			<Message
				key={message.id}
				message={message.message}
				type={message.type}
				interval={message.interval}
				onComplete={() => removeMessage(message.id)}
			/>
		));
	};

	return (
		<>
		{messages.length > 0 && (
			<div className="fixed top-0 w-full md:w-[300px] md:top-[16px] md:right-0 z-[100] p-2 flex flex-col gap-[8px]">
				<RenderMessages />
			</div>
		)}
		</>
	);
};

export default Notifications;
